/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ChallengeType } from './ChallengeType';
import {
    ChallengeTypeFromJSON,
    ChallengeTypeFromJSONTyped,
    ChallengeTypeToJSON,
} from './ChallengeType';
import type { FactorMethod } from './FactorMethod';
import {
    FactorMethodFromJSON,
    FactorMethodFromJSONTyped,
    FactorMethodToJSON,
} from './FactorMethod';

/**
 * 
 * @export
 * @interface OTPChallenge
 */
export interface OTPChallenge {
    /**
     * 
     * @type {string}
     * @memberof OTPChallenge
     */
    id: string;
    /**
     * 
     * @type {ChallengeType}
     * @memberof OTPChallenge
     */
    type: ChallengeType;
    /**
     * 
     * @type {FactorMethod}
     * @memberof OTPChallenge
     */
    authentication_method: FactorMethod;
}

/**
 * Check if a given object implements the OTPChallenge interface.
 */
export function instanceOfOTPChallenge(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "authentication_method" in value;

    return isInstance;
}

export function OTPChallengeFromJSON(json: any): OTPChallenge {
    return OTPChallengeFromJSONTyped(json, false);
}

export function OTPChallengeFromJSONTyped(json: any, ignoreDiscriminator: boolean): OTPChallenge {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': ChallengeTypeFromJSON(json['type']),
        'authentication_method': FactorMethodFromJSON(json['authentication_method']),
    };
}

export function OTPChallengeToJSON(value?: OTPChallenge | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'type': ChallengeTypeToJSON(value.type),
        'authentication_method': FactorMethodToJSON(value.authentication_method),
    };
}

